import { createApp } from 'vue'
import App from './App.vue'
import i18n from './i18n'
import router from './router' // 引入路由配置
// ✨ 1. 引入 Element Plus 的核心库
import ElementPlus from 'element-plus'
// ✨ 2. 必须引入对应的 CSS 样式文件，否则组件会失去样式
import 'element-plus/dist/index.css'

const app = createApp(App)

app.use(i18n)
app.use(router)
app.use(ElementPlus)

app.mount('#app')
